/**
 * ALTIORA · Gamification · Compact XP badge for the AppTopBar.
 *
 * Displays current level icon + streak flame. Full detail on /app/gamification.
 * Polls /api/gamification/state every 60s so newly earned XP shows quickly.
 */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Flame } from "lucide-react";
import { api } from "@/lib/api";

const CHAMPAGNE = "#C5A880";
const IVORY = "#FBF6EA";

export function GamificationBadge() {
  const [state, setState] = useState(null);
  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const { data } = await api.get("/gamification/state");
        if (!cancelled) setState(data);
      } catch { /* silent — user might be logged out */ }
    };
    load();
    const id = setInterval(load, 60_000);
    return () => { cancelled = true; clearInterval(id); };
  }, []);

  if (!state) return null;
  const streak = state.streak?.current || 0;
  return (
    <Link to="/app/gamification"
          data-testid="topbar-gamification"
          className="hidden md:inline-flex items-center gap-2 rounded-md px-2.5 py-1
                        transition hover:opacity-90"
          style={{ border: `1px solid ${CHAMPAGNE}33`, color: `${IVORY}CC` }}
          title={`Niveau ${state.level?.label} · ${state.total_xp} XP`}>
      <span aria-hidden="true">{state.level?.icon || "🌱"}</span>
      <span className="font-mono text-[10px] uppercase tracking-widest"
            style={{ color: IVORY }}>
        {state.total_xp}<span style={{ opacity: 0.6 }}> XP</span>
      </span>
      {streak > 0 && (
        <span className="inline-flex items-center gap-0.5">
          <Flame className="h-3 w-3" style={{ color: "#F59E0B" }} aria-hidden="true" />
          <span className="text-[10px] font-mono" style={{ color: IVORY }}>{streak}</span>
        </span>
      )}
    </Link>
  );
}
